
import { defineComponent } from "vue";

import { CBtn, CIcon, CSlideGroup } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn, CSlideGroup, CIcon },
  props: {
    overlayArrows: {
      type: Boolean,
      default: true,
    },
  },
});
